import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { registrationRoutesConfig } from './auto-registration/registration-config';
import { AutoRegistrationComponent } from './auto-registration/auto-registration.component';

const autoRegistrationRoutes: Routes = [
  {
    path: '',
    component: AutoRegistrationComponent,
    children: [
      { path: '', redirectTo: registrationRoutesConfig.SIGNUP, pathMatch: 'full' },
      {
        path: registrationRoutesConfig.SIGNUP,
        loadComponent: () =>
          import('./auto-registration/sign-up/sign-up.component').then(
            (m) => m.SignUpComponent
          ),
      },
      {
        path: registrationRoutesConfig.RESET_PASSWORD,
        loadComponent: () =>
          import('./auto-registration/sign-up/sign-up.component').then(
            (m) => m.SignUpComponent
          ),
      },
      {
        path: registrationRoutesConfig.CHOOSE_BUSINESS_3,
        loadComponent: () =>
          import(
            './auto-registration/registration-steps/registration-steps.component'
          ).then((m) => m.RegistrationStepsComponent),
      },
      {
        path: registrationRoutesConfig.CHOOSE_BUSINESS_4,
        loadComponent: () =>
          import(
            './auto-registration/registration-steps/registration-steps.component'
          ).then((m) => m.RegistrationStepsComponent),
      },
      {
        path: registrationRoutesConfig.CHOOSE_BUSINESS_5,
        loadComponent: () =>
          import(
            './auto-registration/registration-steps/registration-steps.component'
          ).then((m) => m.RegistrationStepsComponent),
      },
      {
        path: registrationRoutesConfig.VERIFY,
        loadComponent: () =>
          import('./auto-registration/sign-up/sign-up.component').then(
            (m) => m.SignUpComponent
          ),
      },
      {
        path: registrationRoutesConfig.SMART_SUGGESTIONS,
        loadComponent: () =>
          import(
            './auto-registration/smart-suggestions/smart-suggestions.component'
          ).then((m) => m.SmartSuggestionsComponent),
      },
    ],
  },
];

const routes: Routes = [
  ...autoRegistrationRoutes,
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
